import React, { useState } from 'react';
import './faq.css'; // Assuming you're adding the styles to a separate CSS file
import questionIcon from '../../Assets/question icon.png';

const FAQ = () => {
  // State to track which question is open
  const [openQuestion, setOpenQuestion] = useState(null);

  // Toggle the selected question
  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index); // Open/Close logic
  };

  // FAQ Data
  const faqData = [
    {
      question: "Can’t i just get pierced with a gun at the mall?",
      answer: `Getting pierced with a piercing-gun is very unhealthy for your body. A piercing-gun inflicts blunt trauma force to the body (sort of like trying to punch a hole through your arm), which increases the chance for infection and an unpleasant healing process. ALL piercings should be performed with a hollow, surgical steel tri-bevel needle. This will alleviate the problem of “blowout” (having a volcano-like build-up of flesh around the exit hole of you piercing) and decrease chances for infection. The first such problem is the risk of contracting disease. Most guns have plastic parts which cannot be properly sterilized, giving rise to the possibility of spreading bacterial infections, such as those suffered recently by a group of people in Oregon after getting pierced at a mall, or more serious blood-borne diseases such as Hepatitis B and C. The second problem has to do with the shape and composition of the jewelry itself and the force applied by it to the earlobe (or any body part), making healing difficult. These guns were first manufactured to tag livestock, and inflict unnecessary blunt trauma to the tissue. The studs used by the guns have clasps, which trap bacteria and which, when combined with the too-short post used by the jewelry, compress the tissue. This does not allow for any swelling, makes cleaning the site difficult, and reduces the availability of oxygen to the wound. In addition, the metal used for most of the gunned jewelry is of inferior quality and may inhibit healing by causing contact dermatitis or nickel allergies. The best and safest option for any piercing, including earlobes, is to patronize a professional body piercer. These individuals have the proper training to perform safe piercings, unlike most physicians, and certainly unlike the poorly trained clerks piercing people in malls. Professional piercers observe proper sterile procedures, use a single-use, sharp needle that does not damage tissue, and good quality body jewelry made specifically for safe and speedy healing.`
    },
    {
    question: "How long will it take to heal?",
    answer: `That depends. Each area of the body has its own unique healing period and process. 
                Oral and oral/facial piercings tend to heal fastest, while others tend to heal a bit slower. 
                Also, every individual body heals and reacts to piercings in an individualized manner. 
                A general guideline for approximate healing times is as follows:
            - Cheek: 2-3 months
            - Cartilage: 2 months-1 year
            - Earlobe: 6-8 weeks
            - Eyebrow: 6-8 weeks
            - Genitals: 4 weeks-6 months
            - Labret: 6-8 weeks
            - Lip: 6-8 weeks
            - Navel: 6 months-over 1 year
            - Nipple: 2-6 months
            - Nostril: 2 months-1 year
            - Septum: 6-8 weeks
            - Tongue: 4-6 weeks`
    },
    {
      question: "Does getting a piercing hurt?",
      answer: `Most piercings are just a slight pinch for a second, and most of our clients saying, “it was so much easier than I thought it would be”, or “that didn’t hurt at all”`
    },
    {
      question: "What are the piercing requirements for minor?",
      answer: `Piercing of a Minor a under age Requires the parent or guardian to also provide written permission for the minor to receive the piercing also must submit ID CARD (Allowed only ear lobe piercing)
`
    },
    {
      question: "How is it done?",
      answer: `We perform all of our piercings with single use, sterilized surgical needles. They are extremely sharp, therefore making the piercing as painless as possible. You get to watch us break open the needle package, and dispose of the needle immediately after the procedure.`
    },
    {
      question: "How long do my ears hurt after piercing?",
      answer: `It's normal to have some redness, swelling or pain for a couple of days after getting your ears pierced. But your ears should look and feel better each day. If you find that your ears do great and then suddenly start to become red, inflamed or crusty a week or two later, that's usually a sign of infection.`
    },
    {
      question: "Does it hurt? – nipple piercing",
      answer: `While this piercing does pass through thicker tissue than a few other piercings, most people-women especially-are surprised that it is not nearly as bad as they expected. Think of it as one really hard, quick bite. (Well, two actually, if you’re getting both nipples pierced.)`
    },
    {
        question: "How long until i can change my jewelry? – nostril piercing",
        answer: `Wait at least four months. Nostril piercings are not very forgiving if you try to change the jewelry too soon. Not waiting long enough could result in irritation, a tear to the piercing channel, scarring, an increased risk of infection, or difficulty reinserting the jewelry. Make sure you get pierced with jewelry you like and wait until it’s fully healed to change it.`
    },
    {
        question: "Does it hurt? – septum piercing",
        answer: `Septum piercings are usually not a difficult piercing to sit through. The needle (and then jewelry) passes through the thin, soft piece of skin towards the tip of your nose, between the cartilage and the thicker, rigid skin below it. Most people describe it as a strange sensation, one that makes their eyes water and makes them feel like they need to sneeze, but not one that is especially painful.`
    },
    {
        question: "What is the quality of your studs?",
        answer: `We're the best jewelry store for all of your threadless jewelry needs. From Titanium /Surgical steel / Medical earrings to nose rings to nipple jewelry and everything in-between, we've got you covered. Level up your ear and body piercing game with fine jewelry that is guaranteed to look good and last a lifetime.`
    },
    {
        question: "What should i know after getting my bellybutton pierced?",
        answer: `Clean it two to three times a day with saline solution for at least the first month. Avoid tight clothing around your midsection, tanning beds, hot tubs, public pools, and sleeping on your stomach until the piercing is at least mostly healed.`
    },
    {
        question: "How much is it for jewelry change?",
        answer: `Jewelry changes are now 40 AED service to cover PPE (personal protection equipment) costs, plus the cost of the jewelry.`
    },
    {
        question: "What are the painful piercings from most to least?",
        answer: `Nipple Piercing: 8/10
                Anti-tragus Piercing: 8/10
                Dermal Piercing: 7/10
                Conch Piercing: 5 – 6/10
                Wrist Surface Piercing: 6/10
                Septum Piercing: 6/10
                Daith Piercing: 5 – 6/10
                Industrial Piercing: 6/10
                Helix Piercing: 6/10
                Rook Piercings: 6/10
                Tongue Piercing: 4 – 5/10
                Cartilage Piercing: 4/10
                Piercing Stretching: 3/10
                Eyebrow Piercing: 3/10
                Vertical Labret Piercing: 3/10
                Navel Piercing: 2/10
                Complex lip piercings (snake/spider/shark bites): 2/10
                Monroe/Madonna Piercing: 2/10
                Nostril Piercing: 2/10
                Ear Lobe: 1/10 – Least Painful Piercing`
        }
    // Add more FAQ questions and answers here as needed
  ];

  return (
    <div className="faq-section">
      <h2>Frequently Asked Questions</h2>
      {faqData.map((item, index) => (
        <div key={index} className="faq-item">
          <div className="faq-question" onClick={() => toggleQuestion(index)}>
            {/* Add the icon before the question */}
            <img src={questionIcon} alt="Question Icon" className="question-icon" />
            <h6>{item.question}</h6>
            <span className="arrow">{openQuestion === index ? '▲' : '▼'}</span>
          </div>
          {openQuestion === index && (
            <div className="faq-answer">
              {item.answer.split('\n').map((line, lineIndex) => (
                <p key={lineIndex}>{line}</p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
